import type { ListProjectUsersResponse } from '../generated/types.gen';

export function withoutNullProjectUsers(
  users:
    | ReadonlyArray<ListProjectUsersResponse | null | undefined>
    | null
    | undefined
): ListProjectUsersResponse[] {
  if (!Array.isArray(users)) {
    return [];
  }

  return users.filter((user): user is ListProjectUsersResponse => user != null);
}
